<div class="wrapper-row-1">
  <div class="left">
    @if (headerLogo(); as logo) {
      <a class="logo" uiLink link="/">
        <ui-image [data]="logo" objectFit="contain"></ui-image>
      </a>
    }
    @if (showSearch()) {
      <div class="search" uiOverlayBoundary>
        <ng-container *ngTemplateOutlet="searchInputTemplate"></ng-container>
      </div>
    }
  </div>
  <div class="right">
    @if (showLanguageSwitch()) {
      <ui-language-navigation [class.with-login-spacing]="!authorized()"></ui-language-navigation>
    }

    @if (showHeaderActions()) {
      @if (authorized()) {
        @if (showShopNavigation()) {
          <div class="shop-navigation">
            <ui-flyout class="order-manager-flyout" [data]="orderManagerFlyoutConfig()" [useRouterLinks]="true"></ui-flyout>
            <ui-flyout class="user-flyout" [data]="userFlyoutConfig()" [useRouterLinks]="true"></ui-flyout>
            <a class="cart-link" [routerLink]="'/cart'" title="Warenkorb">
              <ui-icon
                class="shopping-cart"
                faName="cart-shopping"
                faStyle="light"
                [matBadge]="displayInCartCount()"
              ></ui-icon>
              <span>Warenkorb</span>
            </a>
          </div>
        } @else if (showUserFlyout()) {
          <ui-flyout class="user-flyout" [data]="userFlyoutConfig()" [useRouterLinks]="true"></ui-flyout>
        }
      } @else if (!this.isAgentAuthorized()) {
        <button (click)="onUserLogin()">
          <ui-icon faName="user" faStyle="light" title="Log-In"></ui-icon>
        </button>
      } @else if (isAgentAuthorized()) {
        <ui-icon
          faName="user-secret"
          faStyle="light"
        ></ui-icon>
      }
    }
  </div>
</div>

<ui-customer-change-bar (customerSelected)="switchCustomer($event)"></ui-customer-change-bar>

@if (showSearch()) {
  <div class="wrapper-row-3">
    <ng-container *ngTemplateOutlet="searchInputTemplate"></ng-container>
  </div>
}

<ng-template #searchInputTemplate>
  <ui-catalog-search-input
    (barcodeClicked)="barcodeClicked.emit()"
    (searchFieldClicked)="searchFieldClicked.emit()"
    (searchSubmit)="searchSubmit.emit($event)"
    [searchText]="searchTextValue()"
  ></ui-catalog-search-input>
</ng-template>
